/* eslint-disable react-hooks/exhaustive-deps */
import React, {useEffect, useRef, useState} from 'react'
import {Header} from '@thryvlabs/maverick'
import {useLocation} from 'react-router'

import {SelectionAdds, ItemContainer} from '../ui/addons-main-components'
import {ThryvValidatedAddons} from './thryv-validated-addons'
import {MonthSemiAnnualSelection} from './month-semiAnnual-selection'

import {
  ADDONS_TYPES,
  SEO_BOTH_PLANS,
  SOCIAL_ADS_BNI_PLAN_CODES,
} from '../../utils/constants'
import {GROUP_ICONS} from '../catalog-components/centers-and-apps'
import {ADD_ON} from '../../utils/addons-data'
import {AddOnMc} from './add-on-mc'
import {useUserRoles} from '../../utils/use-user-roles'
import {useFlags} from 'launchdarkly-react-client-sdk'
import {SEOSummary} from '../catalog-components/seo-summary-v4'
import {SocialAdsV4} from '../catalog-components/social-ads-v4'
import {CTNAddonV4} from './ctn-addon-v4'
import {LeadsLiftV4} from '../catalog-components/lead-lift-view-v4'
import {getAmountToQuantityMap} from '../../utils/lift-lead-options'

const yesNoRadioButtons = [
  {
    label: 'No',
    value: 'No',
    default: true,
  },
  {
    label: 'Yes',
    value: 'Yes',
  },
]
const yesRadioButton = [
  {
    label: 'Yes',
    value: 'Yes',
    default: true,
  },
]
const monthYearRadioButton = [
  {
    label: 'Monthly',
    value: 'monthly',
  },
  {
    label: 'Semi-Annually',
    value: 'semiAnnually',
    default: true,
  },
]
const defaultYesRadioButtons = [
  {
    label: 'No',
    value: 'No',
  },
  {
    label: 'Yes',
    value: 'Yes',
    default: true,
  },
]

const MCPlanConfig = {
  planSelection: true,
  radioButtonOptions: yesRadioButton,
}

const ITEMS_CONFIG = {
  'Thryv Leads': {radioButtonOptions: monthYearRadioButton},
  'Thryv CSN': {planSelection: true, radioButtonOptions: yesNoRadioButtons},
  'SEO Non-Guaranteed': {radioButtonOptions: monthYearRadioButton},
  'SEO Money Back Guarantee': {radioButtonOptions: monthYearRadioButton},
  'AEO & SEO': {planSelection: true, radioButtonOptions: yesNoRadioButtons},
  'AEO & SEO PowerBoost': {
    planSelection: true,
    radioButtonOptions: monthYearRadioButton,
  },
  'SEO Keyword': {
    planSelection: true,
    radioButtonOptions: monthYearRadioButton,
  },
  'Enhanced Accessibility': {
    planSelection: true,
    radioButtonOptions: yesNoRadioButtons,
  },
  'Restricted Access': {
    planSelection: true,
    radioButtonOptions: yesNoRadioButtons,
  },
  'Certified Domain Based Gmails': {
    slider: true,
    planSelection: true,
    radioButtonOptions: yesNoRadioButtons,
    maxValue: 10,
    range: 1,
  },
  'Standard Domain Based Gmail': {
    slider: true,
    planSelection: true,
    radioButtonOptions: yesNoRadioButtons,
    maxValue: 10,
    range: 1,
  },
  'Additional Social Boosting': {
    slider: true,
    radioButtonOptions: yesNoRadioButtons,
    maxValue: 2000,
    range: 100,
    symbolTemplate: `\${0}`,
    fixedAmount: 100,
  },
  'Additional Video Views': {
    slider: true,
    radioButtonOptions: yesNoRadioButtons,
    maxValue: 2000,
    range: 100,
    symbolTemplate: `\${0}`,
    fixedAmount: 100,
  },
  'Google My Business Optimization': {
    planSelection: true,
    radioButtonOptions: yesNoRadioButtons,
  },
  'Marketing Center Plus': {
    planSelection: true,
    radioButtonOptions: yesNoRadioButtons,
  },
  'Marketing Center Foundation': {
    radioButtonOptions: yesNoRadioButtons,
  },
  'Marketing Center Pro': {
    planSelection: true,
    radioButtonOptions: yesNoRadioButtons,
  },
  'Thryv Signature + Expanded Listings': {
    planSelection: true,
    radioButtonOptions: yesNoRadioButtons,
  },
  'Starter Growth Package': {
    planSelection: true,
    radioButtonOptions: yesNoRadioButtons,
  },
  'Expanded Growth Package': {
    planSelection: true,
    radioButtonOptions: yesNoRadioButtons,
  },
  'Thryv Social Posts': {
    planSelection: true,
    radioButtonOptions: yesNoRadioButtons,
  },
  Website: {planSelection: true, radioButtonOptions: yesNoRadioButtons},
  HIPAA: {planSelection: true, radioButtonOptions: yesNoRadioButtons},
  'Marketing Pro Editor': {
    planSelection: true,
    radioButtonOptions: yesNoRadioButtons,
  },
  'Thryv Professional Services': {
    planSelection: true,
    radioButtonOptions: yesNoRadioButtons,
  },
  'Social Ads Bronze': {
    planSelection: true,
    radioButtonOptions: yesNoRadioButtons,
  },
  'Social Ads Silver': {
    planSelection: true,
    radioButtonOptions: yesNoRadioButtons,
  },
  'Social Ads Gold': {
    planSelection: true,
    radioButtonOptions: yesNoRadioButtons,
  },
  'Leads Lift': {
    planSelection: true,
    radioButtonOptions: yesNoRadioButtons,
  },
  'Reporting Center': {
    planSelection: true,
    radioButtonOptions: yesRadioButton,
  },
  'Workforce Center Plus': {
    planSelection: true,
    radioButtonOptions: yesNoRadioButtons,
  },
  'Thryv Social Posts': {
    planSelection: true,
    radioButtonOptions: yesNoRadioButtons,
  },
  'Listing Refresh': {
    planSelection: true,
    radioButtonOptions: yesNoRadioButtons,
  },
  'Strategic Content Creation': {
    planSelection: true,
    radioButtonOptions: yesNoRadioButtons,
  },
  // Geo Add-On was renamed to Thryv Geo Expansion (FULSAS-13419), and the
  // Statewide tier to Statewide/Region. The legacy keys are kept so plans
  // already on an account/in the catalog under the old name still resolve.
  'Geo Add-On Local Select': {
    planSelection: true,
    radioButtonOptions: yesNoRadioButtons,
  },
  'Geo Add-On Metro': {
    planSelection: true,
    radioButtonOptions: yesNoRadioButtons,
  },
  'Geo Add-On Statewide': {
    planSelection: true,
    radioButtonOptions: yesNoRadioButtons,
  },
  'Geo Add-On Nationwide': {
    planSelection: true,
    radioButtonOptions: yesNoRadioButtons,
  },
  'Thryv Geo Expansion Local Select': {
    planSelection: true,
    radioButtonOptions: yesNoRadioButtons,
  },
  'Thryv Geo Expansion Metro': {
    planSelection: true,
    radioButtonOptions: yesNoRadioButtons,
  },
  'Thryv Geo Expansion Statewide/Region': {
    planSelection: true,
    radioButtonOptions: yesNoRadioButtons,
  },
  'Thryv Geo Expansion Nationwide': {
    planSelection: true,
    radioButtonOptions: yesNoRadioButtons,
  },
}

const MC_PLAN_CODES = [
  ...ADD_ON.add_ons['Marketing Center Plus'].addOnCodes,
  ...ADD_ON.add_ons['Marketing Center Pro'].addOnCodes,
  ...ADD_ON.add_ons['Thryv Signature + Expanded Listings'].addOnCodes,
]

const MC_ROLES = [
  'PremisePilot',
  'National',
  'LeadConverter',
  'Admin',
  'InsideDemo',
  'PremiseDemo',
  'Premise',
  'VivialDemo',
  'Australia',
  'AUSalesusers',
  'New Zealand',
  'Inside',
]

const MC_CODES = [
  'addon-4-mc-semi',
  'addon-4-mc-m2m',
  'addon-4-mcpro-m2m',
  'addon-4-mcproenh-m2m',
]
const MC_NEW_ORDER_ROLES = [
  'premisepilot',
  'national',
  'leadconverter',
  'admin',
  'premise',
  'inside',
  'premisedemo',
]

const MC_UPGRADE_ORDER_ROLES = [
  'premise',
  'national',
  'premisedemo',
  'insidedemo',
  'vivialdemo',
  'australia',
  'ausalesusers',
  'new zealand',
  'tss',
  'premisepilot',
  'leadconverter',
  'admin',
  'inside',
]

const getItemCode = (item, addOnCode) => {
  return !addOnCode?.includes('-m2m') && item?.semiAnnually
    ? item?.semiAnnually[0]?.code
    : item?.monthly[0]?.code
}

const getCustomFieldValue = (customFields = [], names = []) => {
  if (!Array.isArray(customFields) || !Array.isArray(names) || !names.length) {
    return null
  }
  const match = customFields.find(field =>
    names.some(
      name =>
        String(field?.name || '').toLowerCase() === String(name).toLowerCase(),
    ),
  )
  return match?.value ?? null
}

const normalizeExternalDomainValue = value => {
  if (value === true) return 'yes'
  if (value === false) return 'no'
  if (typeof value !== 'string') return null
  const normalizedValue = value.toLowerCase()
  if (normalizedValue === 'yes' || normalizedValue === 'true') return 'yes'
  if (normalizedValue === 'no' || normalizedValue === 'false') return 'no'
  return null
}

function AddOns({
  data,
  addProduct,
  removeProduct,
  updateProduct,
  currency,
  selectedCountry,
  listOfProducts,
  totalGmailSeats,
  availableGmailSeats,
  updateAvailableGmailSeats,
  currentAddOns,
  selectedPlan,
  mcDomainConfig,
  setMcDomainConfig,
  selectedIndustry,
  hasCSN = false,
  setShouldIncludeCSNAddon,
  currentGmailItems,
  isUpgrade = false,
  seoDomainConfig,
  setSeoDomainConfig,
  cohortEaid,
  isEaidFound,
  setAllowInvoice,
  setCohortEaid,
  setIsEaidFound,
  setIsLegacyUpgradeAllowed,
  thryvId,
  setIsCohort,
  isLegacySEO,
  accountInfo,
  accountSubscriptionData,
  listOfAddons,
  isNewTLMCAccessible,
  isThryvLeadsAvailable,
  isExternalDomain,
  setIsExternalDomain,
  alphaDomain,
  setAlphaDomain,
}) {
  const [alphaAmount, setAlphaAmount] = useState(null)
  const [alphaProposalId, setAlphaProposalId] = useState(null)
  const [alphaKeyCount, setAlphaKeyCount] = useState(null)
  const [alphaPowerboostCount, setAlphaPowerboostCount] = useState(null)
  const [seoBillingDate, setSeoBillingDate] = useState(null)
  const hydratedSeoDefaults = useRef(false)
  const disableValidateAndProposalInput = false
  const [isKeywordAdded, setKeywordAddStatus] = useState(false)
  const [isPowerboostAdded, setPowerboostAddStatus] = useState(false)
  const [wasItemInCart, setWasItemInCart] = useState({
    thryvLeads: false,
    seo: false,
  })
  const [LLAmount, setLLAmount] = useState(null)
  //const [llQuantity, setllQuantity] = useState(null)
  const {pathname} = useLocation()
  const {roles} = useUserRoles()
  const {frontendMcTlOrders, frontendMcBoostedListings} = useFlags()
  let seoKeywordDetail = currentAddOns.find(
    item => item.addOnCode === 'addon-4-seokey-m2m',
  )
  let seoPowerBoostDetail = currentAddOns.find(
    item => item.addOnCode === 'addon-4-seopb-m2m',
  )

  const isTSS = roles.includes('TSS')
  const {billingPreference} = listOfProducts.find(
    product => product.type === 'selectedPlan' && product.billingPreference,
  )
  const defaultProducts = data.filter(item =>
    currentAddOns.some(
      ({addOnCode}) => addOnCode === getItemCode(item, addOnCode),
    ),
  )
  const disableApps = Array.from(
    new Set(
      [...listOfProducts, ...defaultProducts].reduce((acc, product) => {
        if (product?.disableApps?.length) {
          acc.push(...product.disableApps)
        }
        return acc
      }, []),
    ),
  )

  const isMarketingCenterPlan =
    listOfProducts.some(
      product =>
        product.type === 'selectedPlan' &&
        ADD_ON.add_ons['Marketing Center Plus'].addOnCodes.includes(
          product.planCode,
        ),
    ) &&
    (roles.includes('PremisePilot') ||
      roles.includes('LeadConverter') ||
      roles.includes('Admin'))
  const isUpgradeFlow = pathname === '/order/upgrade'
  const isMCRole = MC_ROLES.some(role => roles.includes(role))
  const isMCAvailableForTSS =
    isTSS && currentAddOns?.some(({addOnCode}) => MC_CODES.includes(addOnCode))

  const newSeoPlanDetails = {}
  const newLLPlanDetails = {}

  data.map(item => {
    if (
      [
        'addon-4-seobase-m2m',
        'addon-4-seopb-m2m',
        'addon-4-seokey-m2m',
      ].includes(item['monthly'][0].code)
    ) {
      newSeoPlanDetails[`${item['monthly'][0].code}`] = {
        name: item.name,
        ...item['monthly'][0],
      }
    }
    return item
  })
  data.map(item => {
    if (['addon-4-leadslift-m2m'].includes(item['monthly'][0].code)) {
      newLLPlanDetails[`${item['monthly'][0].code}`] = {
        name: item.name,
        ...item['monthly'][0],
      }
    }
    return item
  })
  useEffect(() => {
    if (hydratedSeoDefaults.current) return
    const existingSeoDetail = currentAddOns.find(
      item => item.addOnCode === 'addon-4-seobase-m2m',
    )
    const existingKeywordDetail = currentAddOns.find(
      item => item.addOnCode === 'addon-4-seokey-m2m',
    )
    const existingPowerBoostDetail = currentAddOns.find(
      item => item.addOnCode === 'addon-4-seopb-m2m',
    )
    if (
      !existingSeoDetail &&
      !existingKeywordDetail &&
      !existingPowerBoostDetail
    )
      return

    if (existingSeoDetail) {
      const resolvedSeoBillingDate =
        existingSeoDetail.seoBillingDate ||
        existingSeoDetail.startDate ||
        existingSeoDetail.start_date ||
        existingSeoDetail.seoDate ||
        getCustomFieldValue(existingSeoDetail.customFields, [
          'futureBillingDate',
          'Future_Billing_Date',
          'future_billing_date',
          'startDate',
          'start_date',
        ]) ||
        null
      const externalDomainValue = normalizeExternalDomainValue(
        existingSeoDetail.isExternalDomain ??
          existingSeoDetail.externalDomain ??
          getCustomFieldValue(existingSeoDetail.customFields, [
            'isExternalDomain',
            'Is_External_Domain',
            'externalDomain',
            'External_Domain',
          ]),
      )
      setAlphaAmount(existingSeoDetail.subtotal)
      setAlphaProposalId(existingSeoDetail.proposalId || '')
      setAlphaDomain(existingSeoDetail.domain || '')
      setSeoBillingDate(resolvedSeoBillingDate)
      if (typeof setIsExternalDomain === 'function') {
        if (externalDomainValue) {
          setIsExternalDomain(externalDomainValue)
        } else {
          // Historical 4.0 SEO orders did not always persist this flag.
          // Default to internal domain so relaunch UI is enabled/prefilled.
          setIsExternalDomain('no')
        }
      }
    }
    if (existingKeywordDetail) {
      setAlphaKeyCount(existingKeywordDetail.quantity)
    }
    if (existingPowerBoostDetail) {
      setAlphaPowerboostCount(existingPowerBoostDetail.quantity)
    }
    hydratedSeoDefaults.current = true
  }, [currentAddOns, setAlphaDomain, setIsExternalDomain])
  useEffect(() => {
    if (alphaKeyCount !== null) {
      if (seoKeywordDetail) {
        let product = {
          id: `already-included-${seoKeywordDetail.name}`,
          product: seoKeywordDetail.name,
          type: 'addon',
          price: `$${
            (seoKeywordDetail.subtotal / seoKeywordDetail.quantity) *
            alphaKeyCount
              .toFixed(2)
              .toString()
              .replace(/\B(?=(\d{3})+(?!\d))/g, ',')
          }`,
          quantity: alphaKeyCount || seoKeywordDetail.quantity,
          billingPreference: billingPreference,
          planCode: seoKeywordDetail.addOnCode,
        }
        if (alphaKeyCount > seoKeywordDetail.quantity) {
          updateProduct(product, 'product')
        }
      } else {
        let seoKeywordPlan = newSeoPlanDetails[`addon-4-seokey-m2m`]
        if (seoKeywordPlan && Object.keys(seoKeywordPlan).length > 0) {
          let currencyToPick
          if (selectedCountry === 'usa') currencyToPick = 'USD'
          else if (selectedCountry === 'aus') currencyToPick = 'AUD'
          else if (selectedCountry === 'nz') currencyToPick = 'NZD'
          else if (selectedCountry === 'can') currencyToPick = 'CAD'
          else if (selectedCountry === 'gb') currencyToPick = 'GBP'

          let product = {
            id: seoKeywordPlan.id,
            product: seoKeywordPlan.name,
            type: 'addon',
            price: `$${
              seoKeywordPlan.currencies.filter(
                curr => curr.currency === currencyToPick,
              )[0].unitAmount *
              alphaKeyCount
                .toFixed(2)
                .toString()
                .replace(/\B(?=(\d{3})+(?!\d))/g, ',')
            }`,
            quantity: alphaKeyCount || 1,
            billingPreference: billingPreference,
            planCode: seoKeywordPlan.code,
          }
          if (alphaKeyCount !== 0) {
            if (isKeywordAdded) {
              updateProduct(product, 'product')
            } else {
              addProduct([product])
              setKeywordAddStatus(true)
            }
          } else {
            if (isKeywordAdded) {
              removeProduct(seoKeywordPlan.id)
              setKeywordAddStatus(false)
            }
          }
        }
      }
    }
  }, [alphaKeyCount])

  useEffect(() => {
    if (alphaPowerboostCount !== null) {
      if (seoPowerBoostDetail) {
        let product = {
          id: `already-included-${seoPowerBoostDetail.name}`,
          product: seoPowerBoostDetail.name,
          type: 'addon',
          price: `$${
            (seoPowerBoostDetail.subtotal / seoPowerBoostDetail.quantity) *
            alphaPowerboostCount
              .toFixed(2)
              .toString()
              .replace(/\B(?=(\d{3})+(?!\d))/g, ',')
          }`,
          quantity: alphaPowerboostCount || seoPowerBoostDetail.quantity,
          billingPreference: billingPreference,
          planCode: seoPowerBoostDetail.addOnCode,
        }
        if (alphaPowerboostCount > seoPowerBoostDetail.quantity) {
          updateProduct(product, 'product')
        }
      } else {
        let seoPowerboostPlan = newSeoPlanDetails[`addon-4-seopb-m2m`]
        if (seoPowerboostPlan && Object.keys(seoPowerboostPlan).length > 0) {
          let currencyToPick
          if (selectedCountry === 'usa') currencyToPick = 'USD'
          else if (selectedCountry === 'aus') currencyToPick = 'AUD'
          else if (selectedCountry === 'nz') currencyToPick = 'NZD'
          else if (selectedCountry === 'can') currencyToPick = 'CAD'
          else if (selectedCountry === 'gb') currencyToPick = 'GBP'
          let product = {
            id: seoPowerboostPlan.id,
            product: seoPowerboostPlan.name,
            type: 'addon',
            price: `$${
              seoPowerboostPlan.currencies.filter(
                curr => curr.currency === currencyToPick,
              )[0].unitAmount *
              alphaPowerboostCount
                .toFixed(2)
                .toString()
                .replace(/\B(?=(\d{3})+(?!\d))/g, ',')
            }`,
            billingPreference: billingPreference,
            quantity: alphaPowerboostCount || 1,
            planCode: seoPowerboostPlan.code,
          }
          if (alphaPowerboostCount !== 0) {
            if (isPowerboostAdded) {
              updateProduct(product, 'product')
            } else {
              addProduct([product])
              setPowerboostAddStatus(true)
            }
          } else {
            if (isKeywordAdded) {
              removeProduct(seoPowerboostPlan.id)
              setPowerboostAddStatus(false)
            }
          }
        }
      }
    }
  }, [alphaPowerboostCount])

  useEffect(() => {
    if (LLAmount) {
      let LLPlan = newLLPlanDetails[`addon-4-leadslift-m2m`]
      if (LLPlan && Object.keys(LLPlan).length > 0) {
        let product = {
          id: LLPlan.id,
          product: LLPlan.name,
          type: 'addon',
          price: `$${LLAmount.toFixed(2)
            .toString()
            .replace(/\B(?=(\d{3})+(?!\d))/g, ',')}`,
          quantity: getAmountToQuantityMap(selectedCountry)[LLAmount] || 1,
          billingPreference: billingPreference,
          planCode: LLPlan.code,
        }
        if (
          listOfProducts.find(item => item.planCode === 'addon-4-leadslift-m2m')
        ) {
          updateProduct(product, 'product')
        } else {
          addProduct([product])
        }
      }
    }
  }, [LLAmount])

  useEffect(() => {
    if (alphaProposalId && alphaAmount) {
      let seoBasePlan = newSeoPlanDetails[`addon-4-seobase-m2m`]
      if (seoBasePlan && Object.keys(seoBasePlan).length > 0) {
        let product = {
          id: seoBasePlan.id,
          product: seoBasePlan.name,
          type: 'addon',
          price: `$${alphaAmount
            .toFixed(2)
            .toString()
            .replace(/\B(?=(\d{3})+(?!\d))/g, ',')}`,
          quantity: alphaAmount / seoBasePlan.currencies[0].unitAmount || 1,
          domain: alphaDomain,
          proposalId: alphaProposalId,
          seoBillingDate: seoBillingDate || undefined,
          billingPreference: billingPreference,
          planCode: seoBasePlan.code,
        }
        if (
          listOfProducts.find(item => item.planCode === 'addon-4-seobase-m2m')
        ) {
          updateProduct(product, 'product')
        } else {
          addProduct([product])
        }
      }
    }
  }, [alphaProposalId, alphaAmount, alphaDomain, seoBillingDate])

  const getTlInCart = ({product, id}) => {
    if (isUpgradeFlow && id?.includes('already-included')) {
      return product === 'Thryv Leads' || product === 'Thryv Leads MC Add-On'
    }
    return product === 'Thryv Leads' || product === 'Thryv Leads MC Add-On'
  }
  const isTLInCart =
    listOfProducts.some(({product, id}) => getTlInCart({product, id})) ||
    isThryvLeadsAvailable

  function checkIfAddonIsInCart(itemName, type) {
    const itemAddonCodes = ADD_ON.add_ons[itemName].addOnCodes
    const itemType = ADDONS_TYPES[type]
    return (
      listOfProducts.some(({planCode, type}) => {
        if (itemType)
          return itemAddonCodes.includes(planCode) && type === itemType
        return itemAddonCodes.includes(planCode)
      }) ||
      currentAddOns?.some(({addOnCode}) => itemAddonCodes.includes(addOnCode))
    )
  }

  function validateMCRoles() {
    let validRoleIsPresent = false

    let formattedRoles = roles.map(role =>
      role.toLowerCase().replace(/\s/g, ''),
    )
    // New Order -- where none of the MCs are present
    if (!isMCInCart && !isMCProInCart && !isMCProEnhancedInCart) {
      validRoleIsPresent = MC_NEW_ORDER_ROLES.some(role =>
        formattedRoles.includes(role),
      )
      return validRoleIsPresent
    }
    // Upgrade from MC Plus
    if (isMCInCart && !isMCProInCart && !isMCProEnhancedInCart) {
      validRoleIsPresent = MC_UPGRADE_ORDER_ROLES.some(role =>
        formattedRoles.includes(role),
      )
      return validRoleIsPresent
    }
    // Any other scenario - follow the existing user criteria logic
    if (isMCRole || isMCAvailableForTSS) {
      validRoleIsPresent = true
      return validRoleIsPresent
    }
    return validRoleIsPresent
  }
  const BC_PLANS = ['Unlimited', 'Professional', 'Plus', 'Sync']
  const isBCInDefault = BC_PLANS.some(plan =>
    accountInfo?.planName?.toLowerCase().startsWith(plan.toLowerCase()),
  )
  const isMCInCart = checkIfAddonIsInCart('Marketing Center Plus', 'ADD_ON')
  const isMCProInCart = checkIfAddonIsInCart('Marketing Center Pro')
  const isMCProEnhancedInCart = checkIfAddonIsInCart(
    'Thryv Signature + Expanded Listings',
  )
  const isMCFoundationInCart = checkIfAddonIsInCart(
    'Marketing Center Foundation',
  )
  const isSEOInCart = listOfProducts.some(({product}) =>
    product?.includes('SEO'),
  )

  // const leadLift = accountInfo.addOns?.find(
  //   ({addOnCode, quantity}) =>
  //     addOnCode === 'addon-4-leadslift-m2m' && quantity > 0,
  // )

  // if (leadLift) {
  //   // setllQuantity(leadLift.quantity)
  //   // setLLAmount(leadLift.subtotal)
  //   console.log('leadLift', leadLift)
  // }

  // const isOldSEO = listOfProducts.find(
  //   ({product, id}) =>
  //     product === 'SEO Money Back Guarantee' ||
  //     product === 'SEO Non-Guaranteed',
  // )
  const isSEOAlreadyInCart = listOfProducts.find(
    ({product, id}) =>
      product?.includes('SEO') && id.includes('already-included'),
  )
  const isWebsiteInCart = listOfProducts.some(
    ({product}) => product === 'Website',
  )
  const isWebsiteIncluded = currentAddOns?.some(({name}) => name === 'Website')
  const noAddlVidViews = ['aus', 'cayman', 'barbados']
  const hasGMB = currentAddOns?.some(
    ({name}) =>
      name === 'GMB Add-on Monthly' ||
      name === 'GMB Add-on Semi Annually' ||
      name === 'Google My Business Optimization',
  )

  const setItem = item => {
    // GEP-6803: Social Ads BNI is read-only display; never render selectable
    // controls for it from the catalog/upgrade flows. The backend filter in
    // account-service is the primary gate; this is defense in depth.
    const itemCodes = [
      ...(item?.monthly || []),
      ...(item?.semiAnnually || []),
    ].map(c => c?.code)
    if (itemCodes.some(code => SOCIAL_ADS_BNI_PLAN_CODES.includes(code))) {
      return
    }
    const isAddOnSelected = currentAddOns?.some(
      ({addOnCode, name: addOnName}) => {
        const itemCode = getItemCode(item, addOnCode)
        return addOnCode === itemCode || addOnName === item.name
      },
    )
    const isMCPlus = item.name === ADD_ON.add_ons['Marketing Center Plus'].label
    const isMCPro = item.name === ADD_ON.add_ons['Marketing Center Pro'].label
    const isMCProEnhanced =
      item.name === ADD_ON.add_ons['Thryv Signature + Expanded Listings'].label
    // Match by code: the backend names this add-on "TGP Foundation"
    // (plan-name-config.json), which differs from the frontend label.
    const isMCFoundation =
      item.name === ADD_ON.add_ons['Marketing Center Foundation'].label ||
      ADD_ON.add_ons['Marketing Center Foundation'].addOnCodes.includes(
        item?.monthly?.[0]?.code,
      )
    let isDisabled = isAddOnSelected
    const selectedAddOn = currentAddOns?.find(({addOnCode}) => {
      const itemCode = getItemCode(item, addOnCode)
      return addOnCode === itemCode
    })
    const itemConfig = ITEMS_CONFIG[item.name]
    const selectedItemConfig = {
      ...itemConfig,
      radioButtonOptions: defaultYesRadioButtons,
    }

    if (isMCProEnhanced) {
      if (!isMCProEnhancedInCart) {
        return
      }
    }

    if (isMCFoundation) {
      if (!isMCFoundationInCart) {
        return
      }
    }

    if ((isMCPlus || isMCPro) && isMCProEnhancedInCart) return

    if (
      item.name ===
        ADD_ON.add_ons['Thryv Signature + Expanded Listings'].label &&
      (isMCInCart || isMCProInCart)
    )
      return

    if (
      item.name === ADD_ON.add_ons['Website'].label &&
      (isMCProInCart || isMCProEnhancedInCart)
    )
      return

    if (item.name === ADD_ON.add_ons['Additional Social Boosting'].label) {
      return
    }

    if (
      item.name === ADD_ON.add_ons['Additional Social Boosting'].label ||
      item.name === ADD_ON.add_ons['SEO Money Back Guarantee'].label ||
      (item.name === ADD_ON.add_ons['Additional Video Views'].label &&
        noAddlVidViews.includes(selectedCountry))
    )
      return

    if (
      item.name === ADD_ON.add_ons['Google My Business Optimization'].label &&
      !hasGMB
    )
      return
    if (item.name === ADD_ON.add_ons['Thryv Social Posts'].label) {
      if (!isMCInCart && !isMCProInCart && !isMCProEnhancedInCart) {
        return
      } else {
        return (
          <MonthSemiAnnualSelection
            item={item}
            key={item.name}
            currency={currency}
            addProduct={addProduct}
            removeProduct={removeProduct}
            updateProduct={updateProduct}
            itemConfig={
              isMarketingCenterPlan
                ? ITEMS_CONFIG[item.name]
                : isAddOnSelected
                ? selectedItemConfig
                : itemConfig
            }
            listOfProducts={listOfProducts}
            billingPreference={billingPreference}
            availableGmailSeats={availableGmailSeats}
            totalGmailSeats={totalGmailSeats}
            currentGmailItems={currentGmailItems}
            handleUpdateAvailableGmailSeats={updateAvailableGmailSeats}
            isAddOnSelected={isAddOnSelected}
            selectedAddOn={selectedAddOn}
            isDisabled={isDisabled}
            isUpgrade={isUpgrade}
            currentAddOns={currentAddOns}
            isTSS={isTSS}
            disableApps={disableApps}
          />
        )
      }
    }
    if (
      item.name === ADD_ON.add_ons['Starter Growth Package'].label ||
      item.name === ADD_ON.add_ons['Expanded Growth Package'].label
    ) {
      if (isTLInCart) {
        isDisabled = true
      }
      if (!isMCInCart && !isMCProInCart) {
        return
      } else {
        if (!frontendMcBoostedListings) {
          return
        }
        return (
          <MonthSemiAnnualSelection
            item={item}
            key={item.name}
            currency={currency}
            addProduct={addProduct}
            removeProduct={removeProduct}
            updateProduct={updateProduct}
            itemConfig={
              isMarketingCenterPlan
                ? ITEMS_CONFIG[item.name]
                : isAddOnSelected
                ? selectedItemConfig
                : itemConfig
            }
            listOfProducts={listOfProducts}
            billingPreference={billingPreference}
            availableGmailSeats={availableGmailSeats}
            totalGmailSeats={totalGmailSeats}
            currentGmailItems={currentGmailItems}
            handleUpdateAvailableGmailSeats={updateAvailableGmailSeats}
            isAddOnSelected={isAddOnSelected}
            selectedAddOn={selectedAddOn}
            isDisabled={isDisabled}
            isUpgrade={isUpgrade}
            currentAddOns={currentAddOns}
            isTSS={isTSS}
            disableApps={disableApps}
          />
        )
      }
    }
    if (item.name.includes('Social Ads')) {
      if (
        ((selectedCountry === 'aus' ||
          selectedCountry === 'nz' ||
          selectedCountry === 'can') &&
          (isMCInCart ||
            isMCProInCart ||
            isMCProEnhancedInCart ||
            isMCFoundationInCart)) ||
        (selectedCountry === 'usa' &&
          (isMCInCart ||
            isMCProInCart ||
            isMCProEnhancedInCart ||
            isMCFoundationInCart ||
            isBCInDefault))
      ) {
        return (
          <SocialAdsV4
            item={item}
            addProduct={addProduct}
            removeProduct={removeProduct}
            updateProduct={updateProduct}
            listOfProducts={listOfProducts}
            disableApps={disableApps}
            currentAddOns={currentAddOns}
            currency={currency}
          />
        )
      }
      return
    }
    if (
      item.name.includes('Geo Add-On') ||
      item.name.includes('Thryv Geo Expansion')
    ) {
      return (
        <SocialAdsV4
          item={item}
          addProduct={addProduct}
          removeProduct={removeProduct}
          updateProduct={updateProduct}
          listOfProducts={listOfProducts}
          disableApps={disableApps}
          currentAddOns={currentAddOns}
          currency={currency}
          maxQuantity={Number(item.monthly?.[0]?.maxQty) || 1}
          // FULSAS-13425: never let quantity drop below what's already owned.
          lockOwnedQuantity
        />
      )
    }
    if (item.name === 'Call Tracking Number') {
      return (
        <CTNAddonV4
          item={item}
          addProduct={addProduct}
          removeProduct={removeProduct}
          updateProduct={updateProduct}
          listOfProducts={listOfProducts}
          currentAddOns={currentAddOns}
          currency={currency}
        />
      )
    }
    if (item.name === ADD_ON.add_ons['SEO Non-Guaranteed'].label) {
      if (
        selectedCountry !== 'usa' &&
        selectedCountry !== 'aus' &&
        selectedCountry !== 'nz'
      ) {
        // if ((isWebsiteInCart || isWebsiteIncluded || isLegacySEO) && isOldSEO) {
        if (isWebsiteInCart || isWebsiteIncluded || isLegacySEO) {
          const seoMbgItem = data.find(
            addon =>
              addon.name === ADD_ON.add_ons['SEO Money Back Guarantee'].label,
          )
          let isSeoMbgItemDefault = SEO_BOTH_PLANS.includes(selectedPlan?.name)

          if (isSeoMbgItemDefault && isLegacySEO) {
            if (!(isWebsiteInCart || isWebsiteIncluded)) {
              isSeoMbgItemDefault = false
            }
          }
          const mainSeoItemInfo =
            isSeoMbgItemDefault && seoMbgItem ? seoMbgItem : item
          return (
            <AddOnMc
              mcIsOnCart={isSEOInCart}
              mcDomainConfig={seoDomainConfig}
              setMcDomainConfig={setSeoDomainConfig}
              key={mainSeoItemInfo.name}
              setAllowInvoice={setAllowInvoice}
              setIsCohort={setIsCohort}
              setCohortEaid={setCohortEaid}
              setIsEaidFound={setIsEaidFound}
              thryvId={thryvId}
            >
              <ThryvValidatedAddons
                item={mainSeoItemInfo}
                title={mainSeoItemInfo.name}
                addProduct={addProduct}
                removeProduct={removeProduct}
                updateProduct={updateProduct}
                selectedCountry={selectedCountry.toUpperCase()}
                radioButtonOptions={itemConfig?.radioButtonOptions}
                listOfProducts={listOfProducts}
                billingPreference={billingPreference}
                currentAddOns={currentAddOns}
                isTLInCart={isTLInCart}
                isSEOInCart={isSEOAlreadyInCart}
                seoMbgItem={isSeoMbgItemDefault ? item : seoMbgItem}
                isSeoMbgItemDefault={isSeoMbgItemDefault}
                addBorderBottom={false}
                isDisabled={listOfProducts.some(item =>
                  [
                    'addon-4-seobase-m2m',
                    'addon-4-seopb-m2m',
                    'addon-4-seokey-m2m',
                  ].includes(item.planCode),
                )}
              />
            </AddOnMc>
          )
        }
      }
      return
    }
    if (item.name === 'AEO & SEO') {
      if (
        ((selectedCountry === 'aus' ||
          selectedCountry === 'nz' ||
          selectedCountry === 'can') &&
          (isMCInCart ||
            isMCProInCart ||
            isMCProEnhancedInCart ||
            isMCFoundationInCart)) ||
        (selectedCountry === 'usa' &&
          (isMCInCart ||
            isMCProInCart ||
            isMCProEnhancedInCart ||
            isMCFoundationInCart ||
            isBCInDefault))
      ) {
        return (
          <>
            <SEOSummary
              alphaProposalId={alphaProposalId}
              setAlphaProposalId={setAlphaProposalId}
              alphaDomain={alphaDomain}
              setAlphaDomain={setAlphaDomain}
              alphaAmount={alphaAmount}
              setAlphaAmount={setAlphaAmount}
              alphaKeyCount={alphaKeyCount}
              setAlphaKeyCount={setAlphaKeyCount}
              alphaPowerboostCount={alphaPowerboostCount}
              setAlphaPowerboostCount={setAlphaPowerboostCount}
              diableValidateAndProposalInput={disableValidateAndProposalInput}
              isExternalDomain={isExternalDomain}
              setIsExternalDomain={setIsExternalDomain}
              listOfProducts={listOfProducts}
              removeProduct={removeProduct}
              addProduct={addProduct}
              setSeoDomainConfig={setSeoDomainConfig}
              seoBillingDate={seoBillingDate}
              setSeoBillingDate={setSeoBillingDate}
              isSEOAlreadyOnAccount={Boolean(
                currentAddOns.find(
                  item => item.addOnCode === 'addon-4-seobase-m2m',
                ),
              )}
            />
          </>
        )
      }
      return
    }

    if (item.name === 'Thryv Professional Services') {
      const BC_PLANS = ['Unlimited', 'Professional', 'Plus', 'Sync']
      const isBCInDefault = BC_PLANS.some(plan =>
        accountInfo?.planName?.toLowerCase().startsWith(plan.toLowerCase()),
      )
      const isMCInDefault = accountInfo?.addOns?.some(({addOnCode}) =>
        MC_PLAN_CODES.includes(addOnCode),
      )
      if (!(isBCInDefault || isMCInDefault)) {
        return <></>
      } else
        return (
          <MonthSemiAnnualSelection
            item={item}
            key={item.name}
            currency={currency}
            addProduct={addProduct}
            removeProduct={removeProduct}
            updateProduct={updateProduct}
            itemConfig={
              isMarketingCenterPlan
                ? MCPlanConfig
                : isAddOnSelected
                ? selectedItemConfig
                : itemConfig
            }
            listOfProducts={listOfProducts}
            billingPreference={billingPreference}
            availableGmailSeats={availableGmailSeats}
            totalGmailSeats={totalGmailSeats}
            currentGmailItems={currentGmailItems}
            handleUpdateAvailableGmailSeats={updateAvailableGmailSeats}
            isAddOnSelected={isAddOnSelected}
            selectedAddOn={selectedAddOn}
            isDisabled={isDisabled}
            isUpgrade={isUpgrade}
            currentAddOns={currentAddOns}
            isTSS={isTSS}
            disableApps={disableApps}
          />
        )
    }

    if (item.name === 'SEO Keyword' || item.name === 'AEO & SEO PowerBoost') {
      return <></>
    }
    if (item.name === 'Reporting Center') {
      //  if (selectedCountry === 'usa') {
      const BC_PLANS = [
        'unlimited-4-dexyp-m2m',
        'professional-4-dexyp-m2m',
        'plus-4-dexyp-m2m',
      ]
      const MC_PLAN = ['addon-4-mc-m2m', 'addon-4-mcpro-m2m']
      const isMCDefault = accountInfo?.addOns?.some(({addOnCode}) =>
        MC_PLAN.includes(addOnCode),
      )
      const isBCInDefault = BC_PLANS.includes(selectedPlan?.planCode)
      if (
        (!isBCInDefault && !isMCDefault && !isMCInCart && !isMCProInCart) ||
        !isAddOnSelected
      ) {
        return <></>
      } else
        return (
          <MonthSemiAnnualSelection
            item={item}
            key={item.name}
            currency={currency}
            addProduct={addProduct}
            removeProduct={removeProduct}
            updateProduct={updateProduct}
            itemConfig={isAddOnSelected ? selectedItemConfig : itemConfig}
            listOfProducts={listOfProducts}
            billingPreference={billingPreference}
            availableGmailSeats={availableGmailSeats}
            totalGmailSeats={totalGmailSeats}
            currentGmailItems={currentGmailItems}
            handleUpdateAvailableGmailSeats={updateAvailableGmailSeats}
            isAddOnSelected={isAddOnSelected}
            selectedAddOn={selectedAddOn}
            isDisabled={isDisabled}
            isUpgrade={isUpgrade}
            currentAddOns={currentAddOns}
            isTSS={isTSS}
            disableApps={disableApps}
          />
        )
      //   }
      // return
    }
    if (item.name === 'Workforce Center Plus') {
      const WC_PLANS = [
        'unlimited-4-dexyp-m2m',
        'professional-4-dexyp-m2m',
        'plus-4-dexyp-m2m',
        'sync-4-dexyp-m2m',
        'unlimited-3-dexyp-m2m',
        'essential-3-dexyp-m2m',
        'starter-3-dexyp-m2m',
        'sync-website-4-m2m',
        'plus-3-dexyp-m2m',
      ]
      const isWCInDefault = WC_PLANS.includes(selectedPlan?.planCode)
      // Workforce Center Plus is only available for US accounts per BUSREQ (FULSAS-4977)
      if (selectedCountry !== 'usa' || !isWCInDefault) {
        return <></>
      } else
        return (
          <MonthSemiAnnualSelection
            item={item}
            key={item.name}
            currency={currency}
            addProduct={addProduct}
            removeProduct={removeProduct}
            updateProduct={updateProduct}
            itemConfig={isAddOnSelected ? selectedItemConfig : itemConfig}
            listOfProducts={listOfProducts}
            billingPreference={billingPreference}
            availableGmailSeats={availableGmailSeats}
            totalGmailSeats={totalGmailSeats}
            currentGmailItems={currentGmailItems}
            handleUpdateAvailableGmailSeats={updateAvailableGmailSeats}
            isAddOnSelected={isAddOnSelected}
            selectedAddOn={selectedAddOn}
            isDisabled={isDisabled}
            isUpgrade={isUpgrade}
            currentAddOns={currentAddOns}
            isTSS={isTSS}
            disableApps={disableApps}
          />
        )
    }

    if (item.name === 'Leads Lift') {
      if (selectedCountry === 'aus') {
        if (!isMCInCart && !isMCProInCart && !isMCFoundationInCart) {
          return
        }
        return (
          <>
            <LeadsLiftV4
              LLAmount={LLAmount}
              setLLAmount={setLLAmount}
              //  listOfProducts={listOfProducts}
              accountInfo={accountInfo}
            />
          </>
        )
      }
      return
    }
    if (item.name === 'Thryv Leads') {
      if (selectedCountry === 'usa') {
        return (
          <ThryvValidatedAddons
            item={item}
            key={item.name}
            title={item.name}
            addProduct={addProduct}
            removeProduct={removeProduct}
            updateProduct={updateProduct}
            selectedCountry={selectedCountry.toUpperCase()}
            radioButtonOptions={itemConfig?.radioButtonOptions}
            listOfProducts={listOfProducts}
            billingPreference={billingPreference}
            currentAddOns={currentAddOns}
            isTLInCart={isTLInCart}
            isSEOInCart={isSEOAlreadyInCart}
            isCSNInCart={hasCSN}
            isDisabled={
              isNewTLMCAccessible
                ? !isBCInDefault ||
                  isTLInCart ||
                  isMCProEnhancedInCart ||
                  !(isMCInCart || isMCProInCart || isMCFoundationInCart)
                : !frontendMcTlOrders
                ? isMCInCart ||
                  isMCProInCart ||
                  isMCFoundationInCart ||
                  isMCProEnhancedInCart ||
                  !isMarketingCenterPlan
                : false
            }
            setShouldIncludeCSNAddon={setShouldIncludeCSNAddon}
          />
        )
      }
      return
    }
    if (item.name === ADD_ON.add_ons['Enhanced Accessibility'].label) {
      if (isWebsiteInCart) {
        return (
          <MonthSemiAnnualSelection
            item={item}
            key={item.name}
            currency={currency}
            addProduct={addProduct}
            removeProduct={removeProduct}
            updateProduct={updateProduct}
            itemConfig={
              isMarketingCenterPlan
                ? MCPlanConfig
                : isAddOnSelected
                ? selectedItemConfig
                : itemConfig
            }
            listOfProducts={listOfProducts}
            billingPreference={billingPreference}
            availableGmailSeats={availableGmailSeats}
            totalGmailSeats={totalGmailSeats}
            handleUpdateAvailableGmailSeats={updateAvailableGmailSeats}
            isAddOnSelected={isAddOnSelected}
            selectedAddOn={selectedAddOn}
            isDisabled={isDisabled}
            currentAddOns={currentAddOns}
            disableApps={disableApps}
          />
        )
      }
      return
    }

    if (item.name === 'Website') {
      return (
        <MonthSemiAnnualSelection
          item={item}
          key={item.name}
          currency={currency}
          addProduct={addProduct}
          removeProduct={removeProduct}
          updateProduct={updateProduct}
          itemConfig={
            isMarketingCenterPlan
              ? MCPlanConfig
              : isAddOnSelected
              ? selectedItemConfig
              : itemConfig
          }
          listOfProducts={listOfProducts}
          billingPreference={billingPreference}
          availableGmailSeats={availableGmailSeats}
          totalGmailSeats={totalGmailSeats}
          handleUpdateAvailableGmailSeats={updateAvailableGmailSeats}
          isAddOnSelected={isAddOnSelected}
          selectedAddOn={selectedAddOn}
          isDisabled={isDisabled}
          currentAddOns={currentAddOns}
          disableApps={disableApps}
        />
      )
    }

    if (
      [
        ADD_ON.add_ons['Marketing Center Plus'].label,
        ADD_ON.add_ons['Marketing Center Pro'].label,
        ADD_ON.add_ons['Thryv Signature + Expanded Listings'].label,
      ].includes(item.name)
    ) {
      // MC Plus and Pro
      if (
        ['usa', 'aus', 'can'].includes(selectedCountry) &&
        selectedIndustry !== 'sync_leads' &&
        [
          ADD_ON.add_ons['Marketing Center Plus'].label,
          ADD_ON.add_ons['Marketing Center Pro'].label,
        ].includes(item.name) &&
        validateMCRoles()
      ) {
        const isMCProEnhanced =
          item.name ===
          ADD_ON.add_ons['Thryv Signature + Expanded Listings'].label

        return (
          <AddOnMc
            mcIsOnCart={
              isMCPlus
                ? isMCInCart
                : isMCPro
                ? isMCProInCart
                : isMCProEnhancedInCart
            }
            mcDomainConfig={mcDomainConfig}
            setMcDomainConfig={setMcDomainConfig}
            setSeoDomainConfig={setSeoDomainConfig}
            key={item.name}
            isMCInCart={isMCInCart}
            isMCProInCart={isMCProInCart}
            isMCProEnhancedInCart={isMCProEnhancedInCart}
            isMCProEnhanced={isMCProEnhanced}
            cohortEaid={cohortEaid}
            setCohortEaid={setCohortEaid}
            isEaidFound={isEaidFound}
            setAllowInvoice={setAllowInvoice}
            setIsCohort={setIsCohort}
            setIsEaidFound={setIsEaidFound}
            setIsLegacyUpgradeAllowed={setIsLegacyUpgradeAllowed}
            thryvId={thryvId}
          >
            <MonthSemiAnnualSelection
              item={item}
              key={item.name}
              currency={currency}
              addProduct={addProduct}
              removeProduct={removeProduct}
              updateProduct={updateProduct}
              itemConfig={isAddOnSelected ? selectedItemConfig : itemConfig}
              listOfProducts={listOfProducts}
              billingPreference={billingPreference}
              availableGmailSeats={availableGmailSeats}
              totalGmailSeats={totalGmailSeats}
              handleUpdateAvailableGmailSeats={updateAvailableGmailSeats}
              isAddOnSelected={isAddOnSelected}
              selectedAddOn={selectedAddOn}
              // isDisabled={isDisabled}
              isDisabled={
                isNewTLMCAccessible && isTLInCart
                  ? false
                  : frontendMcTlOrders
                  ? isDisabled
                  : isDisabled || isTLInCart
              }
              addBorderBottom={false}
              selectedPlanCode={selectedPlan.planCode}
              currentAddOns={currentAddOns}
              disableApps={disableApps}
            />
          </AddOnMc>
        )
      }
      if (
        ['usa', 'aus', 'can'].includes(selectedCountry) &&
        (isMCRole || isMCAvailableForTSS) &&
        selectedIndustry !== 'sync_leads' &&
        [ADD_ON.add_ons['Thryv Signature + Expanded Listings'].label].includes(
          item.name,
        )
      ) {
        const isMCProEnhanced =
          item.name ===
          ADD_ON.add_ons['Thryv Signature + Expanded Listings'].label

        return (
          <AddOnMc
            mcIsOnCart={
              isMCPlus
                ? isMCInCart
                : isMCPro
                ? isMCProInCart
                : isMCProEnhancedInCart
            }
            mcDomainConfig={mcDomainConfig}
            setMcDomainConfig={setMcDomainConfig}
            setSeoDomainConfig={setSeoDomainConfig}
            key={item.name}
            isMCInCart={isMCInCart}
            isMCProInCart={isMCProInCart}
            isMCProEnhancedInCart={isMCProEnhancedInCart}
            isMCProEnhanced={isMCProEnhanced}
            cohortEaid={cohortEaid}
            setCohortEaid={setCohortEaid}
            isEaidFound={isEaidFound}
            setAllowInvoice={setAllowInvoice}
            setIsCohort={setIsCohort}
            setIsEaidFound={setIsEaidFound}
            setIsLegacyUpgradeAllowed={setIsLegacyUpgradeAllowed}
            thryvId={thryvId}
          >
            <MonthSemiAnnualSelection
              item={item}
              key={item.name}
              currency={currency}
              addProduct={addProduct}
              removeProduct={removeProduct}
              updateProduct={updateProduct}
              itemConfig={isAddOnSelected ? selectedItemConfig : itemConfig}
              listOfProducts={listOfProducts}
              billingPreference={billingPreference}
              availableGmailSeats={availableGmailSeats}
              totalGmailSeats={totalGmailSeats}
              handleUpdateAvailableGmailSeats={updateAvailableGmailSeats}
              isAddOnSelected={isAddOnSelected}
              selectedAddOn={selectedAddOn}
              isDisabled={
                frontendMcTlOrders ? isDisabled : isDisabled || isTLInCart
              }
              addBorderBottom={false}
              selectedPlanCode={selectedPlan.planCode}
              currentAddOns={currentAddOns}
              disableApps={disableApps}
            />
          </AddOnMc>
        )
      }
      return
    }
    // Unknown add-on with no config: skip instead of crashing the page.
    if (!itemConfig) return
    return (
      <MonthSemiAnnualSelection
        item={item}
        key={item.name}
        currency={currency}
        addProduct={addProduct}
        removeProduct={removeProduct}
        updateProduct={updateProduct}
        itemConfig={
          isMarketingCenterPlan
            ? MCPlanConfig
            : isAddOnSelected
            ? selectedItemConfig
            : itemConfig
        }
        listOfProducts={listOfProducts}
        billingPreference={billingPreference}
        availableGmailSeats={availableGmailSeats}
        totalGmailSeats={totalGmailSeats}
        currentGmailItems={currentGmailItems}
        handleUpdateAvailableGmailSeats={updateAvailableGmailSeats}
        isAddOnSelected={isAddOnSelected}
        selectedAddOn={selectedAddOn}
        isDisabled={isDisabled}
        isUpgrade={isUpgrade}
        currentAddOns={currentAddOns}
        isTSS={isTSS}
        disableApps={disableApps}
      />
    )
  }

  const formatProduct = item => {
    const {quantity, name, subtotal, addOnCode} = item
    return {
      id: `already-included-${name}`,
      product: name,
      type: ADDONS_TYPES['ADD_ON'],
      price: `$${(subtotal || 0)
        .toFixed(2)
        .toString()
        .replace(/\B(?=(\d{3})+(?!\d))/g, ',')}`,
      quantity: quantity,
      billingPreference,
      planCode: addOnCode,
    }
  }

  useEffect(() => {
    const itemsToAdd = []
    currentAddOns?.forEach(addon => {
      const isTLorSEO =
        addon.name.includes('SEO') ||
        addon.name === 'Thryv Leads' ||
        addon.name === 'Thryv Leads MC Add-On'
      const isItemInCart = listOfProducts.some(
        ({product}) => product === addon.name,
      )
      const key =
        addon.name === ('Thryv Leads' || 'Thryv Leads MC Add-On')
          ? 'thryvLeads'
          : 'seo'

      if (isTLorSEO && !isItemInCart && !wasItemInCart[key]) {
        itemsToAdd.push(formatProduct(addon))
      }
    })

    if (itemsToAdd.length) {
      const newWasItemInCart = {...wasItemInCart}
      itemsToAdd.forEach(({product}) => {
        if (product === 'Thryv Leads' || product === 'Thryv Leads MC Add-On')
          newWasItemInCart.thryvLeads = true
        else newWasItemInCart.seo = true
      })
      addProduct(itemsToAdd)
      setWasItemInCart(newWasItemInCart)
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [listOfProducts])

  return (
    <SelectionAdds>
      {GROUP_ICONS.filter(({name}) =>
        (data || []).some(item => item.uigroup === name),
      ).map(({name: categoryName}) => (
        <div key={categoryName}>
          <Header fontWeight="bold" variant="h5" className="ml-3">
            {categoryName}
          </Header>
          <ItemContainer>
            {(data || [])
              .filter(item => item.uigroup === categoryName)
              .map((item, i) => (
                <div key={i}>{setItem(item)}</div>
              ))}
          </ItemContainer>
        </div>
      ))}
      <Header fontWeight="bold" variant="h5" className="ml-3">
        Thryv Add-Ons
      </Header>
      <ItemContainer>
        {(data || [])
          .filter(
            item =>
              !GROUP_ICONS.some(({name}) => name === item.uigroup) ||
              item.uigroup === 'Thryv Add-Ons',
          )
          .map((item, index) => (
            <div key={index}>{setItem(item)}</div>
          ))}
      </ItemContainer>
    </SelectionAdds>
  )
}

export {AddOns}
